import { useScrollReveal } from "../../hooks/useScrollReveal";

export const WhatWeDo = () => {
  const [h1Ref, h1Vis] = useScrollReveal();
  const [mb1Ref, mb1Vis] = useScrollReveal(0.1);
  const [fb1Ref, fb1Vis] = useScrollReveal(0.1);
  const [dontRef, dontVis] = useScrollReveal();

  return (
    <section
      id="what-we-do"
      data-testid="what-we-do-section"
      className="bg-white py-28 md:py-40 lg:py-48"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div ref={h1Ref} className={`reveal ${h1Vis ? 'visible' : ''}`}>
          <div className="editorial-rule mb-6" />
          <h2
            data-testid="what-we-do-heading"
            className="font-['Playfair_Display'] font-semibold text-[clamp(36px,5vw,68px)] tracking-[-0.03em] text-[#0F172A] leading-[1.0]"
          >
            Two things.<br/>Both of them well.
          </h2>
        </div>

        {/* Editorial layout, stacked full-width blocks */}
        <div className="mt-20 md:mt-28 space-y-0">
          {/* Media Buying */}
          <div
            ref={mb1Ref}
            data-testid="media-buying-block"
            className={`grid md:grid-cols-[1fr,1.2fr] gap-8 md:gap-16 lg:gap-24 py-16 md:py-20 border-t border-[#E2E8F0] reveal ${mb1Vis ? 'visible' : ''}`}
          >
            <div>
              <h3
                data-testid="media-buying-label"
                className="font-['Playfair_Display'] font-semibold text-[32px] md:text-[40px] lg:text-[48px] tracking-[-0.02em] text-[#0F172A] leading-[1.05]"
              >
                Media Buying
              </h3>
              <div className="mt-5 flex flex-wrap gap-2">
                {["Meta", "Google", "TikTok", "YouTube"].map(p => (
                  <span key={p} className="text-[12px] font-semibold tracking-wide uppercase text-[#0064E0] bg-[#E5F0FF] px-3 py-1.5 rounded-full">
                    {p}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[17px] md:text-[18px] leading-[1.7] text-[#475569]">
                We run paid media across Meta, Google, TikTok, and YouTube.
                Both operators are in the account daily, setting strategy,
                executing tests, adjusting spend, reading the data. Every
                decision gets made by someone who's managed seven-figure
                spend. Not someone who's managing you.
              </p>
            </div>
          </div>

          {/* Funnel Building */}
          <div
            ref={fb1Ref}
            data-testid="funnel-building-block"
            className={`grid md:grid-cols-[1fr,1.2fr] gap-8 md:gap-16 lg:gap-24 py-16 md:py-20 border-t border-[#E2E8F0] reveal ${fb1Vis ? 'visible' : ''}`}
          >
            <div>
              <h3
                data-testid="funnel-building-label"
                className="font-['Playfair_Display'] font-semibold text-[32px] md:text-[40px] lg:text-[48px] tracking-[-0.02em] text-[#0F172A] leading-[1.05]"
              >
                Funnel Building
              </h3>
              <div className="mt-5 flex flex-wrap gap-2">
                {["Landing Pages", "Offer Structure", "CRO"].map(p => (
                  <span key={p} className="text-[12px] font-semibold tracking-wide uppercase text-[#0064E0] bg-[#E5F0FF] px-3 py-1.5 rounded-full">
                    {p}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[17px] md:text-[18px] leading-[1.7] text-[#475569]">
                Ads are only as good as what they point at. We rebuild the
                landing pages, offers, and conversion path so more of your
                paid traffic becomes a lead, a booking, or a sale. Checkout,
                form, or phone call, we tighten every step in between.
              </p>
            </div>
          </div>

          {/* What we don't do */}
          <div
            ref={dontRef}
            data-testid="what-we-dont-do"
            className={`py-16 md:py-20 border-t border-b border-[#E2E8F0] reveal ${dontVis ? 'visible' : ''}`}
          >
            <div className="grid md:grid-cols-[1fr,1.2fr] gap-8 md:gap-16 lg:gap-24">
              <div>
                <h3 className="font-['Playfair_Display'] font-semibold text-[24px] md:text-[28px] text-[#0F172A] tracking-[-0.01em]">
                  What we don't do
                </h3>
              </div>
              <div>
                <p className="text-[17px] md:text-[18px] leading-[1.7] text-[#475569]">
                  Strategy consulting without execution. Content production. Ad
                  creative production (we direct it, we don't film or edit it).
                  Branding. Design systems. Anything that doesn't connect to paid
                  media or funnel performance.
                </p>
                <p className="mt-4 text-[17px] md:text-[18px] leading-[1.7] text-[#0F172A] font-medium">
                  The focus is deliberate. We say no to scope expansion because
                  it protects your results and our attention.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
